import React from 'react'

function Queries() {
    return (

    <div className="query-container container-fluid py-3">
      {/* Header Section */}
      <div className="bg-warning text-center py-3 text-white d-flex justify-content-between align-items-center">
        <span className="fs-5 mx-3">
          Get a free quote now or ask us a question, it's free, simple and fast. We will be happy to answer you.
        </span>
        <a href="/contact" className="btn btn-light btn-sm mx-3">
          GET A QUOTE
        </a>
      </div>

      {/* Cards Section
      <div className=" my-5">
        <div className="row text-center">
          {/* Card 1 */}
          {/* <div className="col-md-4">
            <div className="card shadow-sm m-2 bg-warning text-white rounded">
              <div className="icon-circle bg-secondary mx-auto mb-3">
                <i class="fa-solid fa-pencil"></i>
              </div>
              <h5 className="card-title">SPRAY FOAM INSULATION IN VANCOUVER</h5>
              <p className="card-text">Informations about our service</p>
              <a href="#" className="btn btn-light">
                More information
              </a>
            </div>
          </div> */}
          {/* Card 2 */}
          {/* <div className="col-md-4">
            <div className="card shadow-sm m-2 bg-warning text-white rounded">
              <div className="icon-circle bg-secondary mx-auto mb-3">
                <i class="fa-solid fa-pencil"></i>
              </div>
              <h5 className="card-title">FIREPROOFING IN VANCOUVER</h5>
              <p className="card-text">Informations about our service</p>
              <a href="#" className="btn btn-light">
                More information
              </a>
            </div>
          </div> */}
          {/* Card 3 */}
          {/* <div className="col-md-4">
            <div className="card shadow-sm m-2 bg-warning text-white rounded">
              <div className="icon-circle bg-secondary mx-auto mb-3">
                <i class="fa-solid fa-pencil"></i>
              </div>
              <h5 className="card-title">SLAB JACKING IN VANCOUVER</h5>
              <p className="card-text">Informations about our service</p>
              <a href="#" className="btn btn-light">
                More information
              </a>
            </div>
          </div>
        </div> */}
      {/* </div> */}
       
    </div>
    )
}

export default Queries